import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery, useReactiveVar } from '@apollo/client';
import { ButtonIcon } from '@statsbomb/kitbag-components';
import { GET_PLAYER_BIO } from './getPlayerBio';
import {
  SummaryTile,
  SummaryTileBody,
  SummaryTileCol,
  SummaryTileFooter,
  SummaryTileHeader,
  TileDimmer,
} from '../../../components/Tile/TileSummary.styles';
import { API_COMPETITION } from '../../../utils/constants/api';
import PlayerBioNCAA from './PlayerBio/PlayerBioNCAA';
import PlayerBioNFL from './PlayerBio/PlayerBioNFL';
import { mf_Leagues } from '../../../apollo';
import LoaderInline from '../../../components/LoaderInline/LoaderInline';
import useQueryString from '../../../utils/hooks/useQueryString';

const PlayerBioTile = ({ __storybookCompetition }) => {
  const [displaySummaryOpen, setDisplaySummaryOpen] = useQueryString(
    'summary',
    true
  );
  const [playerBioData, setPlayerBioData] = useState(null);
  const {
    loading: isLoading,
    error: hasError,
    data,
  } = useQuery(GET_PLAYER_BIO);

  useEffect(() => {
    if (data) {
      setPlayerBioData(data.playerBioOverview);
    }
  }, [data]);

  const competitionId = __storybookCompetition || useReactiveVar(mf_Leagues);
  const isNFL = API_COMPETITION[competitionId] === 'NFL';
  const isNCAA =
    API_COMPETITION[competitionId] === 'NCAA' ||
    API_COMPETITION[competitionId] === 'NCAA2';
  // isNCAA? one or two rows
  const minTileHeight = isNCAA ? '146.5px' : '72.5px';

  const handleToggle = () => {
    if (document.startViewTransition) {
      document.startViewTransition(() =>
        setDisplaySummaryOpen(!displaySummaryOpen)
      );
    } else {
      setDisplaySummaryOpen(!displaySummaryOpen);
    }
  };
  return (
    <SummaryTile>
      <SummaryTileHeader>
        <div>
          <h3>Player Information</h3>
        </div>
        <div>
          <ButtonIcon
            onClick={handleToggle}
            variant="secondary"
            shape="pill"
            size="small"
            icon={displaySummaryOpen ? 'ChevronUp' : 'ChevronDown'}
            isDisabled={isLoading}
            title="ChevronUp"
          />
        </div>
      </SummaryTileHeader>
      <SummaryTileBody
        style={{
          minHeight: displaySummaryOpen ? minTileHeight : '0',
          maxHeight: displaySummaryOpen ? '255px' : '0',
        }}
        $margin="0"
        $overflowY="hidden"
      >
        <>
          {data?.length === 0 && !isLoading && (
            <TileDimmer active>
              <p>No Data available</p>
            </TileDimmer>
          )}
          {hasError && !isLoading && (
            <TileDimmer active>
              <p>Error loading data</p>
            </TileDimmer>
          )}
          {isNCAA && <PlayerBioNCAA playerBioData={playerBioData} />}
          {isNFL && <PlayerBioNFL playerBioData={playerBioData} />}
        </>
      </SummaryTileBody>
      <SummaryTileFooter $transparentBackground={!isLoading}>
        <SummaryTileCol>
          {isLoading && displaySummaryOpen && (
            <LoaderInline text="Loading Data" />
          )}
        </SummaryTileCol>
        <SummaryTileCol />
      </SummaryTileFooter>
    </SummaryTile>
  );
};

PlayerBioTile.propTypes = {
  __storybookCompetition: PropTypes.number,
};

export default PlayerBioTile;
